// StatusEditModal.tsx
import React, { useEffect, useState } from "react";
import { Modal, Select } from "antd";
import { TaskExecution, useUpdateTaskExecutionMutation } from "shared/api";

interface Props {
  open: boolean;
  record: TaskExecution | null;
  onClose: () => void;
}

const statusOptions = [
  { label: "COMPLETED", value: "COMPLETED" },
  { label: "FAILED", value: "FAILED" },
  { label: "PENDING", value: "PENDING" },
];

export const StatusEditModal: React.FC<Props> = ({ open, record, onClose }) => {
  const [status, setStatus] = useState<string>("PENDING");
  const [updateTaskExecution, { isLoading }] = useUpdateTaskExecutionMutation();

  useEffect(() => {
    if (record?.status) setStatus(record.status);
  }, [record]);

  const handleOk = async () => {
    if (!record) return;

    await updateTaskExecution({
      id: record.id,
      data: { status },
    });

    onClose();
  };

  return (
    <Modal
      title="Update Status"
      open={open}
      onOk={handleOk}
      onCancel={onClose}
      confirmLoading={isLoading}
      okButtonProps={{
        className: "bg-blue-600 hover:bg-blue-700 text-white",
      }}
    >
      <Select
        style={{ width: "100%" }}
        value={status}
        options={statusOptions}
        onChange={setStatus}
      />
    </Modal>
  );
};
